import React, { useContext, useEffect, useState } from "react";
import "../styles/error.scss";
import AppContext from "../context/context";
import {
  Analysis,
  Container,
  Intro,
  Persona,
  Story,
  StoryBoard,
  ThankYou,
  ThinkBox,
  Thinker,
  UserFlow,
  Wireframe,
} from "../styles/traitStyles";
import T from "../assets/images/trait/T.webp";
import traitLogo from "../assets/images/trait/trait.webp";
import iphone from "../assets/images/trait/iphone.webp";

import ansIcon from "../assets/images/trait/icon/Analysis.webp";
import DesIcon from "../assets/images/trait/icon/Design.webp";
import ResIcon from "../assets/images/trait/icon/Research.webp";
import testIcon from "../assets/images/trait/icon/Test.webp";
import undIcon from "../assets/images/trait/icon/Understand.webp";
import image from "../assets/images/trait/image 4.webp";
import Table from "../components/table";
import profile from "../assets/images/trait/profile.webp";
import story from "../assets/images/trait/storyboard.webp";
import flowchart from "../assets/images/trait/Flowchart.webp";
import wireframes from "../assets/images/trait/wireframe.webp";
import love from "../assets/images/trait/thank.webp";
import { BackIcon } from "./fundapp";

interface myProps {
  firs: number;
  las: number;
  start: number;
  animate: boolean;
}

const Nums = ({ firs, las, start, animate }: myProps) => {
  //   const numList = (num: number) => {
  //     const numbers = Array.from({ length: 5 }, (_, i) => i + num);
  //     return numbers;
  //   };

  const listSlice = (init: number, last: number) => {
    const list = [
      "cover",
      "Intro",
      "design thinking",
      "user story",
      "competitive analysis",
      "user persona",
      "app storyboard",
      "userflow chart",
      "low fidelity wireframes",
      "thank you",
    ];
    const filteredList = list.slice(init, last);
    return filteredList;
  };
  return (
    <div className={`${animate ? "animate" : ""} group`}>
      {listSlice(firs, las).map((item, i) => (
        <a href={`#${item}`}>
          <div className="nums" key={i}>
            <h4>
              {i + start > 9 ? "" : 0}
              {i + start}
            </h4>
            <p>{item}</p>
          </div>
        </a>
      ))}
    </div>
  );
};

const ThinkCard = () => {
  const mapArr = [
    {
      title: "Emphathize",
      question: "What is the problem?",
      ans: " Define the challenge & explore the human context",
      margin: "0",
      icon: ansIcon,
    },
    {
      title: "Define",
      question: "Why is it important?",
      ans: "Understand & create a point of view through User Research & Competitive Analysis",
      margin: "30px",
      icon: ResIcon,
    },
    {
      title: "Ideate",
      question: "Why is it important?",
      ans: "Brainstorm ideas through User Personas, IA & User Flows",
      margin: "60px",
      icon: testIcon,
    },
    {
      title: "Prototype",
      question: "How do we create it?",
      ans: "Sketches, Wireframes & Prototype",
      margin: "90px",
      icon: DesIcon,
    },
    {
      title: "Test",
      question: "Does it work?",
      ans: "Implement the product & start to refine off the feeedback from Internal & Concept testing",
      margin: "50px",
      icon: undIcon,
    },
  ];
  return (
    <ThinkBox>
      {mapArr.map((item, i) => (
        <div className="think-card" key={i} style={{ marginTop: item.margin }}>
          <img src={item.icon} alt="" />
          <h4>{item.title}</h4>
          <p>
            <span>{item.question}</span>
            <br />
            {item.ans}
          </p>
        </div>
      ))}
    </ThinkBox>
  );
};

function TraitApp() {
  const { setTopOn } = useContext(AppContext);
  useEffect(() => {
    setTopOn(true);
  }, [setTopOn]);
  const [animate, setAnimate] = useState(false);
  const scrollAnimation = () => {
    if (window.scrollY >= 65) setAnimate(true);
    else setAnimate(false);
  };
  const [fixed, setFixed] = useState(false);
  const fixedPhone = () => {
    if (window.scrollY >= 335) setFixed(true);
    else setFixed(false);
  };

  window.addEventListener("scroll", scrollAnimation);
  window.addEventListener("scroll", fixedPhone);
  const [slide, setSlide] = useState(false);
  useEffect(() => {
    const timer = setInterval(() => {
      setSlide(!slide);
    }, 6000);
    return () => clearInterval(timer);
  }, [slide]);
  // useEffect(() => {
  //   document.body.style.scale = "1.5";
  //   document.body.style.position = "relative";
  //   document.body.style.overflow = "hidden";
  // }, []);
  return (
    <>
      <BackIcon />
      <Container
        style={{
          background: fixed ? "#DAD4D0" : "",
        }}
      >
        <div className="trait-box">
          <div className="margin-box">
            <img src={T} alt="trait" className={`${fixed ? "lean" : ""} t`} />
            <img
              src={traitLogo}
              alt="T"
              className={`${fixed ? "vanish" : ""} trait`}
            />
            <div className="views">
              <div
                className={`${
                  fixed ? "vanish" : animate ? "animate" : ""
                } view-1`}
              >
                <h3>Appendix</h3>
              </div>
              <div
                className={`${
                  fixed ? "vanish" : animate ? "animate" : ""
                } view-head`}
              >
                <h1>Tra-it</h1>
                <h5>AR Shopping App</h5>
              </div>
            </div>

            <div className="list">
              <Nums firs={0} las={5} start={1} animate={animate} />
              <Nums firs={5} las={10} start={6} animate={animate} />
            </div>
          </div>
          <Intro id="Intro">
            <img src={iphone} alt="phone" className="phone" />
            <div className={`${fixed ? "appear" : ""} text-fill`}>
              <h2>Amazing Shopping experience with Tra-it AR</h2>
              <p>
                Tra-it AR allows you to virtually ‘try-out’ goods from your
                preferred ecommerce vendor. From furniture like sofa, lamps,
                rugs, tables to accessories and clothes, you get to view them
                true-to-scale on Tra-it AR before purchasing.
              </p>
            </div>
          </Intro>
          <Thinker id="design thinking">
            <div className={`${slide ? "slide" : ""} think-head`}>
              <h1>Design Thinking</h1>
              <h6>a framework for innovation</h6>
            </div>
            <ThinkCard />
          </Thinker>
          <Story id="user story">
            <h1 className="header">User Story</h1>
            <div className="story-box">
              <img src={image} alt="" />
              <div className="story-text">
                <p>
                  You recently discovered a piece of furniture when furniture
                  shopping that you adore. Then the agony begins. Does it? or
                  not will it? suit your surroundings? Even if it does fit, will
                  it complement the side table you bought for Christmas last
                  year?
                </p>
                <p>
                  {" "}
                  Shopping apps with augmented reality can help in this
                  situation. They allow you to see a product in your home before
                  you decide to buy it, or if you want to buy a new pair of
                  glasses, they can show you how the glasses will look on you
                  without making a trip to the store.
                </p>
              </div>
            </div>
          </Story>
          <Analysis id="competitive analysis">
            <h1 className="header">Competitive Analysis</h1>
            <Table />
          </Analysis>
          <Persona id="user persona">
            <h1 className="header">User Persona</h1>
            <div className="gray-holder">
              <div className="gray-box">
                <img src={profile} alt="profile" />
                <div className="gray-text">
                  <p>
                    Bayo Adereti is 32, He is married with a Kid in Primary
                    school. He works in the Fashion industry & is currently busy
                    juggling work & home. Very visual person, he likes colors
                    and patterns. Does a lot of online shopping.
                  </p>
                  <div className="gray-flex">
                    <div className="res">
                      <p>Age</p>
                      <h6>33</h6>
                    </div>
                    <div className="res">
                      <p>Market</p>
                      <h6>Analyst</h6>
                    </div>
                    <div className="res">
                      <p>Status</p>
                      <h6>Married</h6>
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div className="box-con">
                <div className="box">
                  <h3>Goals</h3>
                  <ul>
                    <li>
                      Wants to do their first home improvement Project within
                      their budget{" "}
                    </li>
                    <li>
                      Wants to visualize how furniture will look in their
                      apartment before purchasing
                    </li>
                    <li>
                      Wants to know the quantity to purchase and items needed to
                      complete the project
                    </li>
                  </ul>
                </div>
                <div className="box">
                  <h3>PAIN POINTS</h3>
                  <ul>
                    <li>
                      Spending a lot of money on ill-fitting/ mismatched
                      furniture.
                    </li>
                    <li>
                      Home DIYs leads to dust, dirt and trash accumulation.
                    </li>
                    <li>
                      Time wastage on having to try to measure items in
                      real-time to decide if it works for the space.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Persona>
          <StoryBoard id="app storyboard">
            <h1 className="header">APP STORYBOARD</h1>
            <img src={story} alt="story board" />
          </StoryBoard>
          <UserFlow id="userflow chart">
            <h1 className="header">Userflow</h1>
            <h3 className="header">How the app works</h3>
            <div className="flow-flex">
              <img src={flowchart} alt="" />
              <ul>
                <li>
                  The App is easy to use and the user experience is smooth.
                </li>
                <li>
                  On the page where the item is being viewed, the app is
                  accessed through a plug-in within the item’s page on the
                  merchant’s site.
                </li>
                <li>
                  The User will be prompted to scan the site where the object
                  will be placed.
                </li>
                <li>The AR shows you how the item fits within the space.</li>
              </ul>
            </div>
          </UserFlow>
          <Wireframe id="low fidelity wireframes">
            <h1 className="header">Low fidelity</h1>
            <h3 className="header">Wireframes</h3>
            <div className="low-box">
              <img src={wireframes} alt="" />
              <p>
                After completing research, we created a low fidelity wireframe
                with all of the initial features. We tried to implement all
                features, organized and created a full user journey and layout
                on this wireframe.
              </p>
            </div>
          </Wireframe>
          <ThankYou id="thank you">
            <h1 className="header">Thank You!</h1>
            <img src={love} alt="love" />
          </ThankYou>
        </div>
      </Container>
    </>
  );
}

export default TraitApp;
